'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Fragment } from 'react';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
function formatSegment(segment: string) {
  return decodeURIComponent(segment).replace(/[-_]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
export function Breadcrumbs(t0) {
  const $ = _c(16);
  const {
    className
  } = t0;
  const pathname = usePathname();
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  if ($[0] !== className || $[1] !== pathname) {
    const segments = pathname.split("/").filter(Boolean);
    T1 = Breadcrumb;
    t3 = className;
    T0 = BreadcrumbList;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <BreadcrumbItem><BreadcrumbLink asChild={true}><Link href="/">Startseite</Link></BreadcrumbLink></BreadcrumbItem>;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    t2 = segments.map((segment, i) => {
      const href = "/" + segments.slice(0, i + 1).join("/");
      const isLast = i === segments.length - 1;
      const label = formatSegment(segment);
      return <Fragment key={href}><BreadcrumbSeparator /><BreadcrumbItem>{isLast ? <BreadcrumbPage>{label}</BreadcrumbPage> : <BreadcrumbLink asChild={true}><Link href={href}>{label}</Link></BreadcrumbLink>}</BreadcrumbItem></Fragment>;
    });
    $[0] = className;
    $[1] = pathname;
    $[2] = T0;
    $[3] = T1;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    T0 = $[2];
    T1 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[8] !== T0 || $[9] !== t1 || $[10] !== t2) {
    t4 = <T0>{t1}{t2}</T0>;
    $[8] = T0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== T1 || $[13] !== t3 || $[14] !== t4) {
    t5 = <T1 className={t3}>{t4}</T1>;
    $[12] = T1;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}